import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomeContent.css';
import API_BASE_URL from '../../config/api';

// 弹窗横幅配置（换促销时改这里）
const BANNER_CONFIG = {
  enabled: true,
  image: 'WEB POP UP BANNER oct.jpg',
  link: '/promotions',
};

const PopupBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  // ✅ 调试：检查组件是否渲染
  console.log('PopupBanner component rendered');

  useEffect(() => {
    console.log('BANNER_CONFIG.enabled:', BANNER_CONFIG.enabled);
    if (!BANNER_CONFIG.enabled) return;

    console.log('Setting timer to show popup...');
    const timer = setTimeout(() => {
      console.log('Setting isVisible to true');
      setIsVisible(true);
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  // 弹窗打开时锁定背景滚动
  useEffect(() => {
    document.body.style.overflow = isVisible ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isVisible]);

  // 按 Esc 关闭
  useEffect(() => {
    if (!isVisible) return;
    const onKeyDown = (e) => { if (e.key === 'Escape') setIsVisible(false); };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isVisible]);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleBannerClick = () => {
    setIsVisible(false);
    navigate(BANNER_CONFIG.link);
  };

  // ✅ 调试：检查 isVisible 状态
  console.log('isVisible:', isVisible);

  if (!isVisible) return null;

  return (
    <div className="popup-banner-overlay" onClick={handleClose} role="dialog" aria-modal="true" aria-label="Promotion">
      <div className="popup-banner-content" onClick={(e) => e.stopPropagation()}>
        <button className="popup-banner-close" onClick={handleClose} aria-label="Close promotion popup">
          &times;
        </button>
        <img
          src={`${API_BASE_URL}/uploads/promo/popup/${BANNER_CONFIG.image}`}
          alt="Current promotion"
          className="popup-banner-image"
          onClick={handleBannerClick}
          onError={(e) => {
            console.error('Banner image failed to load:', e.target.src);
            setIsVisible(false);
          }}
        />
      </div>
    </div>
  );
};

export default PopupBanner;